<div class="row">
  <div class="col-md-12">
      <div class="card">
          <div class="card-header card-header-icon card-header-rose">
            <div class="card-icon">
              <i class="material-icons"></i>
            </div>
            <h4 class="card-title"> New Client Contact History</h4>
          </div>
          <div class="card-body">
            <div mat-dialog-content>
              <form #visitaNewForm="ngForm" (ngSubmit)="onSubmit()">
                <div class="row">
                  
                 <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating">Purchasing REP</label>
                    <input type="text" class="form-control" placeholder="{{identity.name}} {{identity.surname}}" readonly>
                  </div>
                 </div>
                 <div class="col-md-3">
                    <div class="form-group">
                      <div class="form-group">
                        <label for="fechacontacto">Contact Date</label>
                            <input type="date" class="form-control" name="fechacontacto" #fechacontacto="ngModel" [(ngModel)]="contacthistory.fechacontacto">
                      </div>
                    </div>
                   </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label class="bmd-label-floating">Contact Hour</label>
                        <input type="time" class="form-control" min="00:00:00" max="23:59:00" name="horacontacto" #horacontacto="ngModel" [(ngModel)]="contacthistory.horacontacto"  >
                      </div>
                   </div>
                 </div>
                 <div class="row">

                  <div class="col-md-6">

                    <div class="form-group">
                      <label class="bmd-label-floating">Set a Reminder?</label>
                      <select name="reminder" id="reminder" #reminder="ngModel" [(ngModel)]="contacthistory.reminder" class="form-control" required>
                          <option value=null disabled>Please select an option</option>
                          <option value='YES'>Yes</option>
                          <option value='NO'>No</option>
                      </select>
                      
                    </div>
                   
                  </div>

                    <div *ngIf="contacthistory.reminder == 'YES'" class="col-md-3">
                     <div class="form-group">
                       <div class="form-group">
                         <label for="Date">Reminder Date</label>
                             <input type="date" class="form-control" name="Date" #Date="ngModel" [(ngModel)]="contacthistory.fecha">
                       </div>
                     </div>
                    </div>
                     <div *ngIf="contacthistory.reminder == 'YES'" class="col-md-3">
                       <div class="form-group">
                         <label class="bmd-label-floating">Reminder Hour</label>
                         <input type="time" class="form-control" min="00:00:00" max="23:59:00" name="hora" #hora="ngModel" [(ngModel)]="contacthistory.hora"  >
                       </div>
                    </div>

                 </div>

                 <div class="row" *ngIf="contacthistory.reminder == 'YES'">
                    <div class="col-md-3">
                      <div style="    display: grid;" class="form-group">

                        <label class="bmd-label-floating">Type of Reminder?</label>


                          <mat-checkbox class="check-margin"
                                    name="email"
                                    [(ngModel)]="contacthistory.email">
                              Email
                          </mat-checkbox>
                     
                          <mat-checkbox class="check-margin"
                                    name="notification"
                                    [(ngModel)]="contacthistory.notification">
                              Notification
                          </mat-checkbox>
                      </div>
                    </div>
                 </div>
                  
               
               <div class="row">
                
                
                 <div class="col-md-12">
                  <div class="form-group">
                    <label>Things to remember</label>
                    <div class="form-group">
                        <textarea name="descripcion" #descripcion="ngModel" [(ngModel)]="contacthistory.descripcion"  class="form-control" rows="5"></textarea>
                    </div>
                  </div>
                </div>
                <div mat-dialog-actions>
                  <button mat-button class="btn btn-rose" [disabled]="contacthistory.reminder == 'YES' && (!contacthistory.notification && !contacthistory.email)"  cdkFocusInitial>Save Reminder</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
</div>